import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addserverAd from "./components/addserverAd";
export default {
  name: "serverAd",
  mixins: [loadMoreList],
  components: {
    addserverAd: addserverAd
  },
  data: function data() {
    return {
      pagingReqFn: "serverStateData",
      pagingReqValue: "data",
      drawer: false,
      delIds: [],
      state: [{
        label: '全部',
        value: '0'
      }, {
        label: '启用',
        value: 1
      }, {
        label: '禁用',
        value: 2
      }]
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'serverStateDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};